import React, { useEffect, useState } from "react";
import { Table, Button, Pagination } from "rsuite";

import "../../styles/Master.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

const { Column, HeaderCell, Cell } = Table;

function ReleaseTable({ referenceNumber }) {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const finalData = data.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  async function getInfo() {
    const result = await axiosInstance.post("/api/get-sample-ref", {
      reference_number: referenceNumber,
    });
    const numbers = result.data;
    setData(numbers);
  }

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div className="master-display-table">
      <Table
        virtualized
        height={300}
        data={finalData}
        autoHeight={true}
        affixHeader
        affixHorizontalScrollbar
        rowHeight={50}
        headerHeight={30}
        onRowClick={(rowData) => {}}
      >
        <Column width={130} align="center" fixed>
          <HeaderCell>Reference Number</HeaderCell>
          <Cell dataKey="reference_number" />
        </Column>
        <Column width={130} resizable>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="date" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Dead</HeaderCell>
          <Cell dataKey="dead" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Location</HeaderCell>
          <Cell dataKey="location" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Person Who Conducted Sampling</HeaderCell>
          <Cell dataKey="persons" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Species</HeaderCell>
          <Cell dataKey="species" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Sex</HeaderCell>
          <Cell dataKey="sex" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Weight</HeaderCell>
          <Cell dataKey="weight" />
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Length (CDL in a ball)</HeaderCell>
          <Cell dataKey="length_cdl" />
        </Column>
        <Column width={150} resizable>
          <HeaderCell>Length (Full Body)</HeaderCell>
          <Cell dataKey="length_full_body" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Case History</HeaderCell>
          <Cell dataKey="case_history" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Ectoparasites Comments</HeaderCell>
          <Cell dataKey="ectoparasites_comments" />
        </Column>

        <Column width={250} resizable>
          <HeaderCell>Scale Comments</HeaderCell>
          <Cell dataKey="scale_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Skin Comments</HeaderCell>
          <Cell dataKey="skin_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Blood Comments</HeaderCell>
          <Cell dataKey="blood_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Muscle Comments</HeaderCell>
          <Cell dataKey="muscle_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Spleen Comments</HeaderCell>
          <Cell dataKey="spleen_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Heart Comments</HeaderCell>
          <Cell dataKey="heart_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Liver Comments</HeaderCell>
          <Cell dataKey="liver_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Lung Comments</HeaderCell>
          <Cell dataKey="lung_comments" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Anaethesia Description for Blood Draw</HeaderCell>
          <Cell dataKey="anaethesia_description" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Photos Taken</HeaderCell>
          <Cell dataKey="photos_taken" />
        </Column>
        <Column width={250} resizable>
          <HeaderCell>Observations</HeaderCell>
          <Cell dataKey="observations" />
        </Column>

        <Column width={160} fixed="right">
          <HeaderCell>...</HeaderCell>
          <Cell style={{ padding: "6px" }}>
            {(rowData) => (
              <div>
                <Button
                  appearance="link"
                  onClick={() =>
                    navigate(
                      `/sample/edit/${rowData.id}/${rowData.reference_number}`
                    )
                  }
                >
                  Edit
                </Button>
                <Button
                  appearance="link"
                  onClick={() => {
                    alert(`id:${rowData.id}`);
                    const result = axiosInstance.post("/api/delete-sample", {
                      id: rowData.id,
                    });
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 40, 80, 160, 300]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}

export default ReleaseTable;
